<ng-container *ngIf="height$ | async as height">
  <ng-container *ngIf="activities$ | async as activities">
    <ng-scrollbar *ngIf="activities.entities.length > 0" [className]="'scrollbar-custom'" [ngStyle]="{'max-height.px': height, 'max-width': '100%', 'display': 'flex' }">
      <div class="donors h-100">
        <app-recent-activity *ngFor="let activity of activities.entities; let i = index;" [index]="i"
                             [activity]="activity" [type]="type"></app-recent-activity>
      </div>
    </ng-scrollbar>
    <ng-container *ngIf="activities.entities.length < 1">
      <div class="activities__empty">
        <img class="activities__empty-image" src="/img/svg/activity.svg"/>
        <div class="activities__empty-text">No User Activity Yet</div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
